import { render } from "./PartnerWrapper.vue?vue&type=template&id=5bcc3e58&scoped=true&ts=true"
import script from "./PartnerWrapper.vue?vue&type=script&lang=ts"
export * from "./PartnerWrapper.vue?vue&type=script&lang=ts"

import "./PartnerWrapper.vue?vue&type=style&index=0&id=5bcc3e58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcc3e58"]])

export default __exports__